module.exports = __webpack_public_path__ + "static/media/sega_college_logo.cba9494a.jpeg";